import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { WaitlistButton } from '@/app/(marketing-site)/_components/waitlist/WaitlistButton';
import { QAList, type Question } from '../_components/QAList';
const mentoringQuestions: Question[] = [{
  title: 'Na jakiej platformie odbywają się spotkania z mentorem?',
  content: <>
        Zarówno mentoring, jak i zajęcia grupowe odbywają się przez{' '}
        <a href='https://discord.com' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Discord
        </a>
        . Każdy uczeń otrzymuje link do prywatnego serwera - to tam odbywają się wszystkie zajęcia.
      </>
}, {
  title: 'Jak mogę zapisać się na pierwszą sesję z mentorem?',
  content: <>
        Najlepiej zapisz się na{' '}
        <WaitlistButton plain type='button' className='inline h-auto min-h-0 border-0 bg-transparent p-0 font-semibold text-algoprimary hover:underline'>
          listę oczekujących
        </WaitlistButton>
        . Możesz też skontaktować się z nami telefonicznie lub mailowo.
      </>
}, {
  title: 'Na czym polega program mentorski?',
  content: <>
        Informacje o tym, czym jest mentoring i jak działają nasze programy, znajdziesz na stronie{' '}
        <Link href='/mentoring' className='font-semibold text-algoprimary'>
          mentoringu
        </Link>
        .
      </>
}, {
  title: 'Jakie są koszty programu mentoringowego?',
  content: <>
        Koszty mogą się znacząco różnić w zależności od Twoich potrzeb. Zachęcamy do skorzystania z
        naszego kalkulatora dostępnego na stronie z{' '}
        <Link href='/cennik' className='font-semibold text-algoprimary'>
          cennikiem
        </Link>
        .
      </>
}, {
  title: 'Jak długo trwa program mentorski?',
  content: 'Program mentorski jest subskrypcją i jest płatny raz na 4 tygodnie, raz na 12 tygodni lub raz do roku. Możesz zakończyć subskrypcję w dowolnym momencie - wtedy płatność nie zostanie odnowiona.'
}, {
  title: 'Czy mogę zapisać się na mentoring z dowolnej dziedziny informatyki?',
  content: 'Oferujemy mentoring w wielu dziedzinach informatyki - napisz do nas, a sprawdzimy czy mamy mentora dopasowanego do Twoich potrzeb.'
}, {
  title: 'Czy mogę zmienić mentora w trakcie trwania mentoringu?',
  content: <>
        Oczywiście! Jeśli Twój mentoring trwa dłużej niż miesiąc, możesz poprosić o zmianę mentora.
        Wystarczy, że napiszesz do nas, a znajdziemy Ci kogoś, kto lepiej pasuje do Twoich potrzeb.
      </>
}, {
  title: 'Czy zajęcia mentoringowe są nagrywane?',
  content: <>
        Tak, nagrywamy zajęcia - pomaga nam to kontrolować jakość i daje Ci możliwość powrotu do
        materiału. Nagrania są tylko dla Ciebie i naszego zespołu, nie udostępniamy ich nikomu
        innemu. Zgoda na nagrywanie jest częścią umowy mentoringowej.
      </>
}, {
  title: 'Czy mogę zrezygnować z nagrywania zajęć?',
  content: <>
        Oczywiście! Jeśli nie zgadzasz się na nagrywanie, wystarczy że nas poinformujesz, a my
        dostosujemy umowę.
      </>
}, {
  title: 'Czy mogę prosić o usunięcie nagrań?',
  content: <>
        W dowolnym momencie możesz poprosić o usunięcie nagrań - usuniemy je w ciągu 14 dni od
        zgłoszenia.
      </>
}, {
  title: 'Czy mogę odwołać zajęcia z mentorem?',
  content: <>
        Jasne! Możesz odwołać lub przełożyć zajęcia, ale daj nam znać jak najwcześniej. Jeśli
        odwołasz zajęcia później niż 24 godziny przed ich rozpoczęciem lub się na nich nie pojawisz,
        zajęcia zostaną uznane za zrealizowane.
      </>
}, {
  title: 'Co jeśli mentor odwoła zajęcia?',
  content: <>
        Czasami zdarza się, że mentor musi odwołać zajęcia z ważnych powodów (choroba, awaria
        sprzętu itp.). Poinformujemy Cię mailowo i przez{' '}
        <a href='https://discord.com' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Discord
        </a>{' '}
        najszybciej jak to możliwe. Wspólnie ustalimy nowy termin lub zwrócimy Ci pieniądze -
        zależnie od Twoich preferencji.
      </>
}];
export function QAMentoringSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QAList questions={mentoringQuestions} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}